import { Outlet } from 'react-router';
import { ConfigProvider } from 'antd';

import './css/index.css';

function Root() {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: '#5E81B0',
        },
      }}
    >
      <Outlet />
      
    </ConfigProvider>
  );
}

export default Root;
